import type { CustomerPlan, Resource } from './planTypes'

export const getResourceLimit = (plan: CustomerPlan, resource: Resource): number =>
  plan.plan_licenses
    .filter((license) => license.resource === resource)
    .map((l) => l.limit)
    .reduce((a, b) => a + b, 0) +
  plan.plan_addon_licenses
    .filter((license) => license.resource === resource)
    .map((l) => l.limit)
    .reduce((a, b) => a + b, 0)

export const getResourceUsage = (plan: CustomerPlan, resource: Resource): number =>
  plan.usage.plan_licenses_usage
    .filter((license) => license.resource === resource)
    .map((l) => l.usage)
    .reduce((a, b) => a + b, 0) +
  plan.usage.customer_addon_licenses_usage
    .filter((license) => license.resource === resource)
    .map((l) => l.usage)
    .reduce((a, b) => a + b, 0)
